import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DAYS = ['M', 'T', 'O', 'T', 'F', 'L', 'S'];

export default function HpWeeklyLetter({ refreshKey }) {
  const [l, setL] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API}/hp-daily/weekly-letter`, { withCredentials: true })
      .then((r) => { setL(r.data); if (r.data.is_sunday) setOpen(true); }).catch(() => {});
  }, [refreshKey]);

  if (!l) return null;
  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="neo-btn px-4 py-2 bg-[#FFE8F5] font-bold text-sm" data-testid="hp-letter-open">
        💌 {l.is_sunday ? 'Hampus veckobrev har kommit!' : `Veckans brev hittills (v.${l.week})`}
      </button>
    );
  }
  const acc = l.total ? Math.round((l.correct / l.total) * 100) : null;

  return (
    <section className="relative rounded-3xl border-[3px] border-black p-5 shadow-[5px_5px_0_#000] overflow-hidden"
      style={{ background: 'repeating-linear-gradient(0deg, #FFFBF2 0 26px, #F3E6D0 26px 27px)' }} data-testid="hp-weekly-letter">
      <div className="absolute -top-3 right-6 text-4xl rotate-12" aria-hidden>💌</div>
      <p className="text-[10px] font-bold tracking-[0.25em] uppercase opacity-60">Hampus veckobrev · vecka {l.week}</p>
      <h4 className="font-['Fredoka'] font-bold text-xl mt-1">Kära du,</h4>
      <p className="text-sm italic mt-1" data-testid="hp-letter-line">{l.line}</p>
      <div className="flex gap-1.5 mt-3" data-testid="hp-letter-days">
        {l.days.map((d, i) => (
          <div key={i} className={`w-8 h-8 rounded-full border-2 border-black flex items-center justify-center text-xs font-black ${d ? 'bg-[#F5B841]' : 'bg-white/70'}`}>{d ? '🐹' : DAYS[i]}</div>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3 text-center">
        <div className="bg-white/80 rounded-xl p-2" data-testid="hp-letter-passes"><div className="text-xl font-black">{l.passes}</div><div className="text-[10px] opacity-60">dagspass</div></div>
        <div className="bg-white/80 rounded-xl p-2" data-testid="hp-letter-streak"><div className="text-xl font-black">{l.streak}🔥</div><div className="text-[10px] opacity-60">dagar i rad</div></div>
        <div className="bg-white/80 rounded-xl p-2" data-testid="hp-letter-accuracy"><div className="text-xl font-black">{acc === null ? '–' : `${acc}%`}</div><div className="text-[10px] opacity-60">rätt ({l.correct}/{l.total})</div></div>
        <div className="bg-white/80 rounded-xl p-2" data-testid="hp-letter-cards"><div className="text-xl font-black">{l.cards_reviewed}</div><div className="text-[10px] opacity-60">ordkort</div></div>
      </div>
      {l.strongest && <p className="text-sm mt-3" data-testid="hp-letter-strongest">💪 Starkast: <b>{l.strongest.emoji} {l.strongest.name}</b> ({l.strongest.accuracy}%)</p>}
      {l.weakest && <p className="text-sm" data-testid="hp-letter-weakest">🌱 Växer mest i: <b>{l.weakest.emoji} {l.weakest.name}</b> ({l.weakest.accuracy}%)</p>}
      {l.exams.length > 0 && <p className="text-sm" data-testid="hp-letter-exams">⏱️ Provdag: {l.exams.map((e) => `${e.score}/${e.max} (≈${e.normalized.toFixed(2)})`).join(', ')}</p>}
      {l.extras > 0 && <p className="text-xs opacity-70">+ {l.extras} extra-pass 💛</p>}
      <div className="flex items-center justify-between mt-3">
        <span className="font-['Fredoka'] text-sm">Kram, Hampus 🐹</span>
        <button onClick={() => setOpen(false)} className="text-xs underline opacity-60" data-testid="hp-letter-close">Vik ihop</button>
      </div>
    </section>
  );
}
